import React, { Component, type ReactNode } from 'react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import HoverObserver from '../hover-observer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as moduleStyles from './styles.module.css';

export type SectionProps = {
	width?: number;
	minWidth: number;
	initialWidth?: number;
	title?: string;
	children?: ReactNode;
	collapsible: boolean;
	id: string;
	index: number;
	hoveredSectionIndex?: number | null | undefined;
	onClick: (arg1: number) => void;
	setHovered: (arg1?: number | null | undefined) => void;
	/**
	 * Has to be referentially stable, otherwise will have unnecessary re-renders. Memoize it if needed.
	 */
	icon?: ReactNode;
	tooltip?: string;
	backgroundColor?: string;
};

// eslint-disable-next-line jira/react/no-class-components
class SectionsItem extends Component<SectionProps> {
	static defaultProps = {
		collapsible: true,
	};

	onSectionClick = () => {
		const { onClick, index, setHovered } = this.props;
		onClick(index);
		setHovered(null);
	};

	onSetHovered = (isHovered: boolean) => {
		const { setHovered, index } = this.props;

		isHovered ? setHovered(index) : setHovered(null);
	};

	render() {
		const {
			width = 0,
			minWidth,
			children,
			title = '',
			collapsible,
			hoveredSectionIndex,
			index,
			backgroundColor = '',
			id,
		} = this.props;
		let innerView = children;
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		let onClick = () => {};
		let styleName = moduleStyles.section;
		let styles: React.CSSProperties = { backgroundColor };

		if (width > 0) {
			styles = { ...styles, width };

			if (collapsible && width <= minWidth) {
				styleName += ` ${moduleStyles.collapsedSection}`;
				onClick = this.onSectionClick;
				if (hoveredSectionIndex === index) {
					styles = {
						...styles,
						backgroundColor: token('color.border', colors.N30),
					};
				}
				const dataName = title ? `collapsed-section-${title}` : 'collapsed-section';
				innerView = (
					<HoverObserver onHoverChanged={this.onSetHovered}>
						{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
						<div data-name={dataName} style={styles} />
					</HoverObserver>
				);
			}
		}

		return (
			<div
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className={styleName}
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={styles}
				onClick={onClick}
				role="none"
				id={`portfolio-3-common.sections.item.${id}`}
				data-testid={`portfolio-3-common.sections.item.${id}`}
			>
				{innerView}
			</div>
		);
	}
}

export default SectionsItem;
